import React from 'react';
import 'src/util/interceptor';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import App from './App';
import './index.css';
import './variables.css';
import { Provider } from 'react-redux';
import store from './store';

if (process.env.NODE_ENV === 'production') {
    window.onbeforeunload = () => {
        return true;
    };
}

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
